import React, { useState, useEffect, useRef } from 'react'
import { Flex } from '../../Components/Common/Flex'
import { Text } from '../../Components/Common/Text'
import { Calendar } from 'primereact/calendar'
import { cap } from '../../State'
import { Button } from '../../Components/Common/Button'
import { Card } from '../../Components/Common/Card'
import { Input } from '../../Components/Common/Input'
import { Checkbox } from 'primereact/checkbox'
import { ProgressBar } from 'primereact/progressbar'
import { FC } from '../../Services/FeathersClient'
import { useAuth } from '../../Provider/AuthProvider'

const defaultDataRange = [new Date(new Date().getFullYear(), new Date().getMonth(), 1), new Date()]

const clientsOptions = [
  { label: 'Blueteam', value: 'getStatsBlueteamXlsx' },
  { label: 'BCD', value: 'getStatsBcdXlsx' },
  { label: 'Gattinoni', value: 'getStatsGattinoniXlsx' },
  // { label: 'Misto', value: 'getStatsMixedXlsx' },
  { label: 'Completo', value: 'getStatsMixedVerticalXlsx' }
]

export const StatisticheAziende = () => {
  const [datesSearch, setDatesSearch] = cap.datesSearchStats.useState()
  const [dateRange, setDateRange] = useState(defaultDataRange)
  const [selectedClient, setSelectedClient] = useState()
  const [groupByDay, setGroupByDay] = useState(false)
  const [includeDetail, setIncludeDetail] = useState(false)
  const { user: userObj = {} } = useAuth()
  const { user = {} } = userObj || {}
  const { email } = user || {}
  const [emailXls, setEmailXls] = useState(email || '')
  const [loading, setLoading] = useState(false)
  const [progressData, setProgressData] = useState({ step: 0, totalSteps: 1, label: '' })
  const [elapsed, setElapsed] = useState(0)
  const timerRef = useRef(null)

  useEffect(() => {
    if (datesSearch?.every((d) => d instanceof Date)) setDateRange([datesSearch[0], datesSearch[1]])
  }, [datesSearch])

  useEffect(() => {
    if (selectedClient === 'getStatsMixedXlsx') setGroupByDay(false)
  }, [selectedClient])

  useEffect(() => {
    const handler = (data) => setProgressData(data)
    FC.socket.on('statsProgress', handler)
    return () => {
      FC.socket.off('statsProgress', handler)
      if (timerRef.current) clearInterval(timerRef.current)
    }
  }, [])

  const downloadStats = async () => {
    setLoading(true)
    setElapsed(0)
    setProgressData({ step: 0, totalSteps: 1, label: 'Connessione...' })
    timerRef.current = setInterval(() => setElapsed(prev => prev + 1), 1000)
    const startDate = dateRange[0].getFullYear() + '-' + (dateRange[0].getMonth() + 1).toString().padStart(2, '0') + '-' + dateRange[0].getDate().toString().padStart(2, '0')
    const endDate = dateRange[1].getFullYear() + '-' + (dateRange[1].getMonth() + 1).toString().padStart(2, '0') + '-' + dateRange[1].getDate().toString().padStart(2, '0')
    try {
      const res = await FC.service('stats').get(selectedClient, { query: { action: 'sendAgencyReport', email: emailXls, groupByDay, includeDetail, startDate, endDate } })
      if (res.ok) window.growl.show({ severity: 'success', summary: 'Email inviata', detail: 'Report inviato con successo' })
    } catch (e) {
      window.growl.show({ severity: 'error', summary: 'Errore', detail: e.message || 'Errore durante la generazione del report' })
    } finally {
      clearInterval(timerRef.current)
      timerRef.current = null
      setLoading(false)
      setProgressData({ step: 0, totalSteps: 1, label: '' })
    }
  }

  const progressPercent = loading ? Math.round((progressData.step / progressData.totalSteps) * 100) : 0
  const formatElapsed = (s) => s >= 60 ? `${Math.floor(s / 60)}m ${s % 60}s` : `${s}s`

  return (
    <Flex fw>
      <Text value='Statistiche Servizi' bold title size={20} />
      <Card style={{ width: '100%', marginTop: 20 }}>
        <Flex fw js row style={{ marginTop: 20 }} wrap>
          <Input
            dropdown options={clientsOptions} label='Cliente' style={{ width: 300 }}
            value={selectedClient} id='client' onChange={(e) => setSelectedClient(e.client)}
          />
          <Calendar
            hideOnRangeSelection
            value={datesSearch} selectionMode='range' onChange={(e) => setDatesSearch(e.value)}
            locale='it' dateFormat='dd/mm/yy' style={{ width: 250, marginLeft: 10 }}
          />
          <Text value='Raggruppa per giorno' style={{ marginLeft: 10 }} />
          <Checkbox checked={groupByDay} onChange={(e) => setGroupByDay(e.checked)} style={{ marginLeft: 10 }} disabled={selectedClient === 'getStatsMixedXlsx'} />
          <Text value='Includi dettaglio' style={{ marginLeft: 10 }} />
          <Checkbox checked={includeDetail} onChange={(e) => setIncludeDetail(e.checked)} style={{ marginLeft: 10 }} disabled={!['getStatsBcdXlsx', 'getStatsGattinoniXlsx', 'getStatsBlueteamXlsx', 'getStatsMixedVerticalXlsx'].includes(selectedClient)} />
          <Input label='Email' style={{ marginLeft: 10, width: 350 }} value={emailXls} onChange={(e) => setEmailXls(e.email)} id='email' />
          <Button
            label={loading ? 'Generazione in corso...' : 'Invia Report Email'}
            icon={loading ? 'fa-duotone fa-spinner-third fa-spin' : 'fa-duotone fa-envelope'}
            style={{ marginLeft: 10 }}
            onClick={downloadStats}
            disabled={loading || !selectedClient || !emailXls?.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)}
          />
        </Flex>
        {loading && (
          <Flex fw style={{ marginTop: 16, padding: '0 12px' }}>
            <ProgressBar value={progressPercent} style={{ width: '100%', height: 22 }} />
            <Flex row jb fw style={{ marginTop: 8 }}>
              <Text value={`${progressData.label || 'In attesa...'}`} size={13} style={{ color: '#555', fontWeight: 500 }} />
              <Text value={`Step ${progressData.step}/${progressData.totalSteps} · ${formatElapsed(elapsed)}`} size={12} style={{ color: '#888' }} />
            </Flex>
          </Flex>
        )}
        {(selectedClient === 'getStatsBlueteamXlsx' || selectedClient === 'getStatsMixedXlsx') &&
          <Text value='Per avere i dati sulle anomalie di Blueteam, mandare ad Andrea il file di log di Edok' style={{ marginTop: 20, marginLeft: 12 }} />}
      </Card>
    </Flex>
  )
}
